import { render, staticRenderFns } from "./NfcReport.vue?vue&type=template&id=45b73861&scoped=true"
import script from "./NfcReport.vue?vue&type=script&lang=js"
export * from "./NfcReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b73861",
  null
  
)

export default component.exports